//Buscar Cálculos de manejo do setor
export class CheckIfHasSectorUseCase{
  constructor(repository) {
    this.repository = repository
  }
  async execute(ID_SECTOR){
    const result= await this.repository.checkIfEmpty(ID_SECTOR)
    return result
  }
}
